import React from 'react'
import BaseButton from './BaseButton'

function HeaderButton(props) {
  const { opaque, ...rest } = props
  return (
    <BaseButton
      {...rest}
      className={`${
        props.opaque
          ? 'text-secondary bg-white-85 hover:bg-white-50 border-transparent hover:text-primary'
          : ''
      }`}
    />
  )
}

export default HeaderButton
